










import CheckboxList from './CheckboxList.vue';
import {defineComponent} from "@vue/composition-api";
import {useGetters, useMutations} from "vuex-composition-helpers";

export default defineComponent({
  name: 'Scopes',
  components: {
    CheckboxList
  },
  setup: () => {
    const {scopeList} = useGetters('scope', ['scopeList'])
    const {setActiveScope} = useMutations('scope', ['setActiveScope'])

    return {
      scopeList,
      setActiveScope
    }
  }
})
